/**
 * Notification API (authenticated users)
 * ──────────────────────────────────────
 * Uses the shared axios instance (attaches the Bearer token). Realtime arrivals
 * come over the socket as 'notification:new'; these calls are for initial load,
 * the unread badge, and marking read.
 */
import api from './axios';

export const notificationApi = {
  list: (params = {}) => api.get('/notifications', { params }),
  unreadCount: () => api.get('/notifications/unread-count'),
  markRead: (id) => api.patch(`/notifications/${id}/read`),
  markAllRead: () => api.patch('/notifications/read-all'),
  remove: (id) => api.delete(`/notifications/${id}`),
};

export default notificationApi;